var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconDep(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.5 21C17.4706 21 21.5 16.9706 21.5 12C21.5 7.02944 17.4706 3 12.5 3C7.52944 3 3.5 7.02944 3.5 12C3.5 16.9706 7.52944 21 12.5 21ZM13.25 8C13.25 7.58579 12.9142 7.25 12.5 7.25C12.0858 7.25 11.75 7.58579 11.75 8V14.1893L9.53033 11.9697C9.23744 11.6768 8.76256 11.6768 8.46967 11.9697C8.17678 12.2626 8.17678 12.7374 8.46967 13.0303L11.9697 16.5303C12.2626 16.8232 12.7374 16.8232 13.0303 16.5303L16.5303 13.0303C16.8232 12.7374 16.8232 12.2626 16.5303 11.9697C16.2374 11.6768 15.7626 11.6768 15.4697 11.9697L13.25 14.1893V8Z",
    fill: "#D1FE17"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDep);
export default __webpack_public_path__ + "static/media/icon_dep.fef5d1c20eff198242df3a24d2f2ab52.svg";
export { ForwardRef as ReactComponent };